// The agent service's one address, REACT_APP_AI_AGENT_WS_URL: the WebSocket URL as configured, and the same host over
// HTTP(S) for its REST routes (/models, /agent/llm-login/*, /volume). Unset or empty means the local bridge.
export const AGENT_WS_URL = process.env.REACT_APP_AI_AGENT_WS_URL || "ws://localhost:8080";
export const AGENT_HTTP = AGENT_WS_URL.replace(/^wss:\/\//, "https://").replace(/^ws:\/\//, "http://");
